import { el, setAttr } from 'redom';

import { stringToSVG } from 'utilities';

import imageIconString from 'assets/images/send-message-icon.svg?raw';

import './index.scss';

const imageIcon = stringToSVG(imageIconString);

class SendMessageButton {

  constructor(configuration) {

    this.sendMessage = configuration.sendMessage;

    this.button = el('button.send-message-button', {
      onclick: this.handleClick.bind(this)
    }, [
      imageIcon.cloneNode(true)
    ]);
    this.el = el('x-tooltip', {
      text: 'Send'
    }, [this.button]);

  }

  async handleClick(event) {
    event.preventDefault();
    event.stopPropagation();
    this.sendMessage();

  }

  update(configuration) {
    this.sendMessage = configuration.sendMessage;
  }

  setEnabled(enabled) {

    setAttr(this.button, {
      disabled: enabled === false
    });

  }

}

export default SendMessageButton;